import type { TMessages } from '../../../types/TMessages'

export const messages = {
  label: 'Адрес вашего склада',
} satisfies TMessages
